import React from 'react';

import { Grid } from '@cowbell/ui';

import classes from './OrgFormSection.module.css';

interface OrgFormSectionProps {
  readonly title: string;
}

/**
 * A labelled break between groups of fields on an organization profile panel.
 *
 * <p>Renders as a full-width row of the panel's own Grid rather than wrapping
 * the fields it heads, so the fields either side keep sharing rows with each
 * other and nothing beneath it is re-indented.
 */
export const OrgFormSection = ({ title }: OrgFormSectionProps) => {
  return (
    <Grid.Col span={12} className={classes.section}>
      <span className={classes.label}>{title}</span>
    </Grid.Col>
  );
};

export default OrgFormSection;
